import * as z from "zod/v4";

export const restockItemsForReturn = {
  name: "restockItemsForReturn" as const,
  input: z.object({
    returnId: z.string(),
    itemsToRestock: z.optional(z.record(z.string(), z.boolean())),
    shipHeroBins: z.optional(z.record(z.string(), z.string())),
  }),
  output: z.literal("SUCCESS"),
};
